import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/[folder]/[slug]/ProjectContent.tsx");
